// extracted by mini-css-extract-plugin
export default {"channelLane":"dwK7MEO71ZQE_UwaUSJq","vertical":"lmlcQAqgtr0Wi8ek9T3t"};